














import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
    components: {},
})
export default class PageDescribe extends Vue {
    @Prop({
        default: '',
    })
    public page: string;
    @Prop({
        default: '',
    })
    public contant: string;
    @Prop({
        default: '',
    })
    public styleArr: string;

    @Prop({
        default: '',
    })
    public icon: string;

    public created() {}
    public mounted() {}
}
